import { useParams } from '@tanstack/react-router';

import { toAgentId, useGetAgent } from './api';

export const useGetAgentFromPath = () => {
  const { agentId } = useParams({ strict: false });
  return useGetAgent(toAgentId(agentId));
};
